import { hasValue } from './type';

export const pathSegments = (path) => (Array.isArray(path) ? path : path?.split('.'));

export const getter = (obj, path) => {
  const segments = pathSegments(path);
  if (!segments?.length) {
    return obj;
  }

  let current = obj;
  for (let idx = 0; idx < segments.length; idx++) {
    const field = segments[idx];
    if (!hasValue(current?.[field])) {
      return;
    }

    current = current[field];
  }

  return current;
};

export const setter = (obj, path, value) => {
  const segments = pathSegments(path);
  if (!segments?.length) {
    return;
  }
  let current = obj;
  for (let idx = 0; idx < segments.length - 1; idx++) {
    const field = segments[idx];
    if (!hasValue(current?.[field])) {
      current[field] = {};
    }

    current = current[field];
  }

  current[segments[segments.length - 1]] = value;
};
